import { Device, FromDevice } from '@helpers/media';
import Chevron from '@img/icons/chevron.svg';
import { Icon } from '@stories/Widgets/ProductDetail/CareIcons/CareIcons.hybrid';
import React, { FunctionComponent } from 'react';
import { ProductFeatureIcon } from './ProductStandardsFeatures.api';
import { ProductStandardsFeaturesStyles as S } from './ProductStandardsFeatures.styles';

import Bleach from '@img/icons/care/bleach.svg';
import Chemical from '@img/icons/care/chemical.svg';
import GentleDrying from '@img/icons/care/gentaldrying.svg';
import Iron from '@img/icons/care/iron.svg';
import Tumbler from '@img/icons/care/tumbler.svg';
import FourtyDegrees from '@img/icons/care/wash40.svg';

export interface ProductStandardsFeaturesProps {
  hideTitleOnMobile: boolean;
  linkText?: string | null;
  linkUrl?: string | null;
  icons?: ProductFeatureIcon[] | null;
  tab?: number;
}

const getCareIcon = (url: string): React.ReactNode => {
  const iconCast: Icon = Number(url);

  switch (iconCast) {
    case Icon.Bleach:
      return <Bleach />;
    case Icon.Chemical:
      return <Chemical />;
    case Icon.GentleDrying:
      return <GentleDrying />;
    case Icon.Iron:
      return <Iron />;
    case Icon.Tumbler:
      return <Tumbler />;
    case Icon.FourtyDegrees:
      return <FourtyDegrees />;
  }
};

const ProductStandardsFeatures: FunctionComponent<ProductStandardsFeaturesProps> = (props) => {
  if (!props.icons || props.icons.length === 0) {
    return null;
  }

  const renderLink = (): React.ReactNode => {
    if (!props.linkText || !props.linkUrl) {
      return null;
    }

    return (
      <S.IconLink href={props.linkUrl} target="_blank">
        {props.linkText} <Chevron />
      </S.IconLink>
    );
  };

  return (
    <S.Container>
      <S.IconList tab={props.tab} grid={props.icons.some((feature) => feature.iconText)}>
        {props.icons.map((feature, i) => (
          <S.IconWrapper key={`ProdcutStandardsFeatures_Feature_${i}`}>
            {props.tab === 1
              ? getCareIcon(feature.iconUrl)
              : feature.iconMarkup && <S.Icon dangerouslySetInnerHTML={{ __html: feature.iconMarkup }} />}
            {feature.iconText && <S.IconText>{feature.iconText}</S.IconText>}
          </S.IconWrapper>
        ))}
      </S.IconList>
      <FromDevice device={Device.Tablet}>{renderLink()}</FromDevice>
    </S.Container>
  );
};

export default ProductStandardsFeatures;
